// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Enhanced Dashboard Container */
.dashboard-container {
  min-height: 100vh;
  background: linear-gradient(135deg, var(--neutral-50) 0%, var(--primary-50) 100%);
  position: relative;
}

/* Dashboard Main Layout */
.dashboard-main {
  max-width: 1400px;
  margin: 0 auto;
  padding: var(--space-8);
  min-height: calc(100vh - 120px);
  width: 100%;
  overflow-x: hidden;
  position: relative;
  z-index: 1;
}


/* Member Directory Section */
.member-directory-section {
  margin-top: 1rem;
  padding: 0 1rem;
  max-width: 100%;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

/* Responsive Design */
@media (max-width: 768px) {
  .member-directory-section {
    padding: 0 0.5rem;
    margin-top: 0.5rem;
  }

  .dashboard-main {
    padding: 0.5rem 0;
  }
}

.dashboard-container::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(circle at 20% 80%, var(--primary-100) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, var(--secondary-100) 0%, transparent 50%),
    radial-gradient(circle at 40% 40%, var(--info-100) 0%, transparent 50%);
  opacity: 0.3;
  z-index: -1;
  pointer-events: none;
}

/* Dashboard Main Content - Consolidated with existing .dashboard-main */

/* Loading State */
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
  font-size: 1.2rem;
  color: #7f8c8d;
}

/* Overview Section */
.overview-section h2 {
  color: #2c3e50;
  font-size: 2rem;
  margin-bottom: 2rem;
}

.welcome-message {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 2rem;
}

.welcome-message p {
  color: #7f8c8d;
  font-size: 1.1rem;
  margin: 0;
  line-height: 1.6;
}

/* Enhanced Stats Grid */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: var(--space-6);
  margin-bottom: var(--space-8);
}

.stat-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  padding: var(--space-8);
  border-radius: var(--radius-xl);
  box-shadow:
    var(--shadow-lg),
    0 0 0 1px rgba(255, 255, 255, 0.2);
  text-align: center;
  transition: all var(--transition-normal);
  position: relative;
  overflow: hidden;
  border-left: 4px solid var(--primary-500);
}

.stat-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, var(--primary-500) 0%, var(--primary-600) 100%);
  opacity: 0;
  transition: opacity var(--transition-normal);
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow:
    var(--shadow-2xl),
    0 0 0 1px rgba(255, 255, 255, 0.3);
}

.stat-card:hover::before {
  opacity: 0.05;
}

.stat-card h3 {
  color: var(--neutral-600);
  font-size: var(--text-sm);
  font-weight: var(--font-semibold);
  margin: 0 0 var(--space-4) 0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  position: relative;
  z-index: 1;
}

.stat-number {
  color: var(--neutral-800);
  font-size: var(--text-4xl);
  font-weight: var(--font-bold);
  margin: 0;
  position: relative;
  z-index: 1;
  background: linear-gradient(135deg, var(--primary-600) 0%, var(--primary-800) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Enhanced Quick Access */
.quick-access {
  margin-bottom: var(--space-8);
}

.quick-access h3 {
  color: var(--neutral-800);
  font-size: var(--text-2xl);
  font-weight: var(--font-bold);
  margin-bottom: var(--space-6);
  background: linear-gradient(135deg, var(--primary-600) 0%, var(--primary-800) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.access-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: var(--space-6);
}

.access-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  padding: var(--space-8);
  border-radius: var(--radius-xl);
  box-shadow:
    var(--shadow-lg),
    0 0 0 1px rgba(255, 255, 255, 0.2);
  text-align: center;
  transition: all var(--transition-normal);
  position: relative;
  overflow: hidden;
  cursor: pointer;
}

.access-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, var(--primary-500) 0%, var(--primary-600) 100%);
  opacity: 0;
  transition: opacity var(--transition-normal);
}

.access-card:hover {
  transform: translateY(-6px);
  box-shadow:
    var(--shadow-2xl),
    0 0 0 1px rgba(255, 255, 255, 0.3);
}

.access-card:hover::before {
  opacity: 0.1;
}

.access-icon {
  color: var(--primary-600);
  font-size: var(--text-4xl);
  margin-bottom: var(--space-4);
  position: relative;
  z-index: 1;
  transition: all var(--transition-normal);
}

.access-card:hover .access-icon {
  transform: scale(1.1);
  color: var(--primary-700);
}

.access-card h4 {
  color: var(--neutral-800);
  font-size: var(--text-xl);
  font-weight: var(--font-semibold);
  margin: 0 0 var(--space-2) 0;
  position: relative;
  z-index: 1;
}

.access-card p {
  color: #7f8c8d;
  margin: 0 0 1.5rem 0;
  line-height: 1.5;
}

.access-btn {
  background: #3498db;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.access-btn:hover {
  background: #2980b9;
}

/* Unused activity and user management styles removed - handled by specific components */

/* User management styles removed - handled by EnhancedUserManagement component */

/* Settings and profile styles removed - handled by specific components */

/* Member, audit, and resource styles removed - handled by specific components */

/* Responsive Design */
@media (max-width: 768px) {
  .dashboard-main {
    padding: 1rem;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }

  .access-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {

  .stat-card,
  .access-card {
    padding: 1.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/Dashboard.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,iFAAiF;EACjF,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,+BAA+B;EAC/B,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;;AAGA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;2EAGyE;EACzE,YAAY;EACZ,WAAW;EACX,oBAAoB;AACtB;;AAEA,wEAAwE;;AAExE,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,2DAA2D;EAC3D,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,uBAAuB;EACvB,+BAA+B;EAC/B;;sCAEoC;EACpC,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mFAAmF;EACnF,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B;;sCAEoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,iCAAiC;EACjC,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,6BAA6B;EAC7B,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,mFAAmF;EACnF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,6BAA6B;EAC7B,6BAA6B;EAC7B,mFAAmF;EACnF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,uBAAuB;EACvB,+BAA+B;EAC/B;;sCAEoC;EACpC,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mFAAmF;EACnF,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B;;sCAEoC;AACtC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,iCAAiC;EACjC,4BAA4B;EAC5B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wFAAwF;;AAExF,iFAAiF;;AAEjF,yEAAyE;;AAEzE,gFAAgF;;AAEhF,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;;EAEE;;IAEE,eAAe;EACjB;AACF","sourcesContent":["/* Enhanced Dashboard Container */\n.dashboard-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, var(--neutral-50) 0%, var(--primary-50) 100%);\n  position: relative;\n}\n\n/* Dashboard Main Layout */\n.dashboard-main {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: var(--space-8);\n  min-height: calc(100vh - 120px);\n  width: 100%;\n  overflow-x: hidden;\n  position: relative;\n  z-index: 1;\n}\n\n\n/* Member Directory Section */\n.member-directory-section {\n  margin-top: 1rem;\n  padding: 0 1rem;\n  max-width: 100%;\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .member-directory-section {\n    padding: 0 0.5rem;\n    margin-top: 0.5rem;\n  }\n\n  .dashboard-main {\n    padding: 0.5rem 0;\n  }\n}\n\n.dashboard-container::before {\n  content: '';\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background:\n    radial-gradient(circle at 20% 80%, var(--primary-100) 0%, transparent 50%),\n    radial-gradient(circle at 80% 20%, var(--secondary-100) 0%, transparent 50%),\n    radial-gradient(circle at 40% 40%, var(--info-100) 0%, transparent 50%);\n  opacity: 0.3;\n  z-index: -1;\n  pointer-events: none;\n}\n\n/* Dashboard Main Content - Consolidated with existing .dashboard-main */\n\n/* Loading State */\n.loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 50vh;\n  font-size: 1.2rem;\n  color: #7f8c8d;\n}\n\n/* Overview Section */\n.overview-section h2 {\n  color: #2c3e50;\n  font-size: 2rem;\n  margin-bottom: 2rem;\n}\n\n.welcome-message {\n  background: white;\n  padding: 2rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  margin-bottom: 2rem;\n}\n\n.welcome-message p {\n  color: #7f8c8d;\n  font-size: 1.1rem;\n  margin: 0;\n  line-height: 1.6;\n}\n\n/* Enhanced Stats Grid */\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: var(--space-6);\n  margin-bottom: var(--space-8);\n}\n\n.stat-card {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  padding: var(--space-8);\n  border-radius: var(--radius-xl);\n  box-shadow:\n    var(--shadow-lg),\n    0 0 0 1px rgba(255, 255, 255, 0.2);\n  text-align: center;\n  transition: all var(--transition-normal);\n  position: relative;\n  overflow: hidden;\n  border-left: 4px solid var(--primary-500);\n}\n\n.stat-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, var(--primary-500) 0%, var(--primary-600) 100%);\n  opacity: 0;\n  transition: opacity var(--transition-normal);\n}\n\n.stat-card:hover {\n  transform: translateY(-4px);\n  box-shadow:\n    var(--shadow-2xl),\n    0 0 0 1px rgba(255, 255, 255, 0.3);\n}\n\n.stat-card:hover::before {\n  opacity: 0.05;\n}\n\n.stat-card h3 {\n  color: var(--neutral-600);\n  font-size: var(--text-sm);\n  font-weight: var(--font-semibold);\n  margin: 0 0 var(--space-4) 0;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  position: relative;\n  z-index: 1;\n}\n\n.stat-number {\n  color: var(--neutral-800);\n  font-size: var(--text-4xl);\n  font-weight: var(--font-bold);\n  margin: 0;\n  position: relative;\n  z-index: 1;\n  background: linear-gradient(135deg, var(--primary-600) 0%, var(--primary-800) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Enhanced Quick Access */\n.quick-access {\n  margin-bottom: var(--space-8);\n}\n\n.quick-access h3 {\n  color: var(--neutral-800);\n  font-size: var(--text-2xl);\n  font-weight: var(--font-bold);\n  margin-bottom: var(--space-6);\n  background: linear-gradient(135deg, var(--primary-600) 0%, var(--primary-800) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.access-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: var(--space-6);\n}\n\n.access-card {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  padding: var(--space-8);\n  border-radius: var(--radius-xl);\n  box-shadow:\n    var(--shadow-lg),\n    0 0 0 1px rgba(255, 255, 255, 0.2);\n  text-align: center;\n  transition: all var(--transition-normal);\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n}\n\n.access-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, var(--primary-500) 0%, var(--primary-600) 100%);\n  opacity: 0;\n  transition: opacity var(--transition-normal);\n}\n\n.access-card:hover {\n  transform: translateY(-6px);\n  box-shadow:\n    var(--shadow-2xl),\n    0 0 0 1px rgba(255, 255, 255, 0.3);\n}\n\n.access-card:hover::before {\n  opacity: 0.1;\n}\n\n.access-icon {\n  color: var(--primary-600);\n  font-size: var(--text-4xl);\n  margin-bottom: var(--space-4);\n  position: relative;\n  z-index: 1;\n  transition: all var(--transition-normal);\n}\n\n.access-card:hover .access-icon {\n  transform: scale(1.1);\n  color: var(--primary-700);\n}\n\n.access-card h4 {\n  color: var(--neutral-800);\n  font-size: var(--text-xl);\n  font-weight: var(--font-semibold);\n  margin: 0 0 var(--space-2) 0;\n  position: relative;\n  z-index: 1;\n}\n\n.access-card p {\n  color: #7f8c8d;\n  margin: 0 0 1.5rem 0;\n  line-height: 1.5;\n}\n\n.access-btn {\n  background: #3498db;\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.access-btn:hover {\n  background: #2980b9;\n}\n\n/* Unused activity and user management styles removed - handled by specific components */\n\n/* User management styles removed - handled by EnhancedUserManagement component */\n\n/* Settings and profile styles removed - handled by specific components */\n\n/* Member, audit, and resource styles removed - handled by specific components */\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .dashboard-main {\n    padding: 1rem;\n  }\n\n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .access-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n\n  .stat-card,\n  .access-card {\n    padding: 1.5rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
